import { useTranslation } from 'react-i18next';
import { DesignIcon } from '@monorepo/nova-icons';
import { designTokens, Stack, Typography } from '@monorepo/nova-ui';

export const CartHeader = () => {
  const { t } = useTranslation('hubCommon');

  return (
    <>
      <Stack alignItems="center">
        <DesignIcon useMuiSvgIcon={false} iconName="CartBox" />
      </Stack>

      <Typography
        variant="body2"
        fontWeight={designTokens.typography.fontWeights.semiBold}
        textAlign="center"
      >
        {t('cart.header.line1')}
        <br />
        {t('cart.header.line2')}
      </Typography>
    </>
  );
};
